export type TStatus =
  | "Em processamento"
  | "Autorizada"
  | "Autorizada em contingência"
  | "Rejeitada"
  | "Denegada"
  | "Cancelada"
  | "Inutilizada";

export type TNature =
  | "001 - Compra"
  | "002 - Venda"
  | "003 - Transferência"
  | "004 - Devolução"
  | "005 - Importação"
  | "006 - Exportação"
  | "007 - Remessa"
  | "008 - Retorno"
  | "009 - Outras entradas"
  | "010 - Outras saídas"
  | "011 - Serviços - ISSQN"
  | "012 - Lançamento de Crédito"
  | "013 - Recebimento"
  | "014 - Ressarcimento"
  | "015 - Serviço - ICMS";

export const natureOptions = [
  "001 - Compra",
  "002 - Venda",
  "003 - Transferência",
  "004 - Devolução",
  "005 - Importação",
  "006 - Exportação",
  "007 - Remessa",
  "008 - Retorno",
  "009 - Outras entradas",
  "010 - Outras saídas",
  "011 - Serviços - ISSQN",
  "012 - Lançamento de Crédito",
  "013 - Recebimento",
  "014 - Ressarcimento",
  "015 - Serviço - ICMS",
];

export const invoiceStatusOptions = [
  "Em processamento",
  "Autorizada",
  "Autorizada em contingência",
  "Rejeitada",
  "Denegada",
  "Cancelada",
  "Inutilizada",
];

export const issuedInvoicesMock = {
  count: 12,
  current_page: 1,
  pages: [{ "1": "" }],
  results: [
    {
      model: 65,
      number: 10234,
      series: 2,
      issue_date: "2025-09-15T00:00:00.000Z",
      amount: 5432.1,
      order: { number: 98765, url: "https://example.com/order/98765" },
      nature: "001 - Compra" as TNature,
      recipient: null,
      status: "Autorizada em contingência" as TStatus,
      xml_url: "https://example.com/xml/10234",
      pdf_url: "https://example.com/pdf/10234",
      access_key: "35230512345678000199550010001023451234567890",
      uuid: "a1b2c3d4-e5f6-7890-ab12-cd34ef56ab78",
    },
    {
      model: 55,
      number: 56789,
      series: 3,
      issue_date: "2025-08-22T12:30:00.000Z",
      amount: 12000.0,
      order: { number: 45678, url: "" },
      nature: "004 - Devolução" as TNature,
      recipient: { name: "João da Silva", document_number: "123.456.789-00" },
      status: "Rejeitada" as TStatus,
      rejection: {
        code: "611",
        reason: "Rejeição: cEAN inválido",
        details:
          "O código de barras EAN informado não é válido para o produto informado.",
      },
      xml_url: "",
      pdf_url: "",
      access_key: "35230598765432000111550030005678998765432109",
      uuid: "b2c3d4e5-f678-9012-ab34-cd56ef78ab90",
    },
    {
      model: 1,
      number: 11133333,
      series: 5,
      issue_date: "2025-10-01T08:15:00.000Z",
      amount: 999999.99,
      order: { number: 343411223, url: "https://example.com/order/11223" },
      nature: "011 - Serviços - ISSQN" as TNature,
      recipient: {
        name: "Gamma Serviços",
        document_number: "11.222.333/0001-44",
      },
      status: "Em processamento" as TStatus,
      xml_url: "https://example.com/xml/33333",
      pdf_url: "",
      access_key: "35230511222333000144550050003333311222333441",
      uuid: "c3d4e5f6-7890-1234-ab56-cd78ef90ab12",
    },
    {
      model: 55,
      number: 10001,
      series: 1,
      issue_date: "2025-09-01T16:45:00.000Z",
      amount: 1500.5,
      order: { number: 5001, url: "https://example.com/order/5001" },
      nature: "001 - Compra" as TNature,
      recipient: { name: "Maria Oliveira", document_number: "987.654.321-00" },
      status: "Autorizada" as TStatus,
      xml_url: "https://example.com/xml/10001",
      pdf_url: "https://example.com/pdf/10001",
      access_key: "35230512345678000101550010001000112345678012",
      uuid: "d4e5f678-9012-3456-ab78-cd90ef12ab34",
    },
    {
      model: 65,
      number: 10002,
      series: 2,
      issue_date: "2025-09-05T10:00:00.000Z",
      amount: 3200.0,
      order: { number: 5002, url: "" },
      nature: "002 - Venda" as TNature,
      recipient: {
        name: "Beta Comércio",
        document_number: "23.456.789/0001-02",
      },
      status: "Em processamento" as TStatus,
      xml_url: "",
      pdf_url: "",
      access_key: "35230523456789000102550020001000223456789023",
      uuid: "e5f67890-1234-5678-ab90-cd12ef34ab56",
    },
    {
      model: 1,
      number: 10003,
      series: 3,
      issue_date: "2025-09-10T14:20:00.000Z",
      amount: 780.99,
      order: { number: 5003, url: "https://example.com/order/5003" },
      nature: "003 - Transferência" as TNature,
      recipient: { name: "Carlos Souza", document_number: "321.654.987-00" },
      status: "Rejeitada" as TStatus,
      rejection: {
        code: "302",
        reason: "Rejeição: Irregularidade fiscal do destinatário",
        details:
          "O destinatário possui pendências fiscais impeditivas para a operação.",
      },
      xml_url: "https://example.com/xml/10003",
      pdf_url: "",
      access_key: "35230534567890000103550030001000334567890034",
      uuid: "f6789012-3456-7890-ab12-cd34ef56ab78",
    },
    {
      model: 55,
      number: 10004,
      series: 4,
      issue_date: "2025-09-12T09:00:00.000Z",
      amount: 5000.0,
      order: { number: 5004, url: "" },
      nature: "004 - Devolução" as TNature,
      recipient: { name: "Delta S.A.", document_number: "45.678.901/0001-04" },
      status: "Denegada" as TStatus,
      denegation: {
        code: "301",
        reason: "Denegação: Uso indevido da numeração",
        details:
          "A numeração da nota fiscal foi utilizada de forma indevida ou duplicada.",
      },
      xml_url: "",
      pdf_url: "https://example.com/pdf/10004",
      access_key: "35230545678901000104550040001000445678901045",
      uuid: "67890123-4567-8901-ab23-cd45ef67ab89",
    },
    {
      model: 65,
      number: 10005,
      series: 5,
      issue_date: "2025-09-15T18:30:00.000Z",
      amount: 12000.75,
      order: { number: 5005, url: "https://example.com/order/5005" },
      nature: "005 - Importação" as TNature,
      recipient: {
        name: "Epsilon Import",
        document_number: "56.789.012/0001-05",
      },
      status: "Cancelada" as TStatus,
      xml_url: "https://example.com/xml/10005",
      pdf_url: "",
      access_key: "35230556789012000105550050001000556789012056",
      uuid: "78901234-5678-9012-ab34-cd56ef78ab90",
    },
    {
      model: 1,
      number: 10006,
      series: 6,
      issue_date: "2025-09-18T07:10:00.000Z",
      amount: 300.0,
      order: { number: 5006, url: "" },
      nature: "006 - Exportação" as TNature,
      recipient: { name: "Zeta Export", document_number: "67.890.123/0001-06" },
      status: "Inutilizada" as TStatus,
      xml_url: "",
      pdf_url: "",
      access_key: "35230567890123000106550060001000667890123067",
      uuid: "89012345-6789-0123-ab45-cd67ef89ab01",
    },
    {
      model: 55,
      number: 10007,
      series: 7,
      issue_date: "2025-09-20T11:55:00.000Z",
      amount: 450.25,
      order: { number: 5007, url: "https://example.com/order/5007" },
      nature: "007 - Remessa" as TNature,
      recipient: {
        name: "Eta Remessas",
        document_number: "78.901.234/0001-07",
      },
      status: "Autorizada" as TStatus,
      xml_url: "https://example.com/xml/10007",
      pdf_url: "https://example.com/pdf/10007",
      access_key: "35230578901234000107550070001000778901234078",
      uuid: "90123456-7890-1234-ab56-cd78ef90ab12",
    },
    {
      model: 65,
      number: 10008,
      series: 8,
      issue_date: "2025-09-22T13:40:00.000Z",
      amount: 9999.99,
      order: { number: 5008, url: "" },
      nature: "008 - Retorno" as TNature,
      recipient: {
        name: "Theta Retornos",
        document_number: "89.012.345/0001-08",
      },
      status: "Em processamento" as TStatus,
      xml_url: "",
      pdf_url: "",
      access_key: "35230589012345000108550080001000889012345089",
      uuid: "01234567-8901-2345-ab67-cd89ef01ab23",
    },
    {
      model: 1,
      number: 10009,
      series: 9,
      issue_date: "2025-09-25T15:25:00.000Z",
      amount: 250.0,
      order: { number: 5009, url: "https://example.com/order/5009" },
      nature: "009 - Outras entradas" as TNature,
      recipient: {
        name: "Iota Entradas",
        document_number: "90.123.456/0001-09",
      },
      status: "Rejeitada" as TStatus,
      rejection: {
        code: "204",
        reason: "Rejeição: Duplicidade de NF-e",
        details: "Já existe uma NF-e emitida com a mesma chave de acesso.",
      },
      xml_url: "https://example.com/xml/10009",
      pdf_url: "",
      access_key: "35230590123456000109550090001000990123456090",
      uuid: "12345678-9012-3456-ab78-cd90ef12ab34",
    },
    {
      model: 55,
      number: 10010,
      series: 10,
      issue_date: "2025-09-28T19:50:00.000Z",
      amount: 8000.0,
      order: { number: 5010, url: "" },
      nature: "010 - Outras saídas" as TNature,
      recipient: {
        name: "Kappa Saídas",
        document_number: "01.234.567/0001-10",
      },
      status: "Autorizada" as TStatus,
      xml_url: "",
      pdf_url: "https://example.com/pdf/10010",
      access_key: "35230501234567000110550100001001001234567001",
      uuid: "23456789-0123-4567-ab90-cd12ef34ab56",
    },
  ],
};

export type TIssuedInvoice = (typeof issuedInvoicesMock.results)[0];
